import {
  convertedCodesToNamesMap,
  GeoBlockingTemplates,
  GeoBlockingTemplatesMap
} from '@/components/GeoBlockingTemplatesList/types'

import { States } from '../_legacy/GeoBlocking/types'
import {
  CanadaStateMap,
  GeoBlockingMap,
  USStateMap
} from '../_legacy/GeoBlocking/utils/GeoBlockingData'

export const stateToName = (
  stateCode: string,
  statesArray: States,
  acc: convertedCodesToNamesMap
) => {
  const location = statesArray.country === 'USA' ? 'US States' : 'Canadian States'
  const indexOfCurrentState = statesArray.subdivisions.findIndex(
    (subdivision) => subdivision.code === stateCode
  )
  const currentState = statesArray.subdivisions[indexOfCurrentState]
  return {
    ...acc,
    [location]: acc[location] ? [...acc[location], currentState.name] : [currentState.name]
  }
}
export const convertCountryCodesToNames = (countryCodes: string[]): convertedCodesToNamesMap => {
  return countryCodes.reduce((acc: convertedCodesToNamesMap, curr) => {
    if (curr.includes('US-')) {
      return stateToName(curr, USStateMap, acc)
    }
    if (curr.includes('CA-')) {
      return stateToName(curr, CanadaStateMap, acc)
    } else {
      const currentCountry = GeoBlockingMap.countries[curr].name
      return {
        ...acc,
        Countries: acc.Countries ? [...acc.Countries, currentCountry] : [currentCountry]
      }
    }
  }, {})
}

export const createPopulatedTemplateMap = (
  templates: GeoBlockingTemplates
): GeoBlockingTemplatesMap => {
  return templates.reduce((acc, curTemplate) => {
    const populatedLocations = convertCountryCodesToNames(curTemplate.geoListField)
    return { ...acc, [curTemplate.id]: populatedLocations }
  }, {})
}
